export default __webpack_public_path__ + "static/media/Raleway-SemiBold.243af299.ttf";